






























































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import { omegaup } from '../../omegaup';
import omegaup_Countdown from '../Countdown.vue';
import omegaup_Markdown from '../Markdown.vue';

@Component({
  components: {
    'omegaup-countdown': omegaup_Countdown,
    'omegaup-markdown': omegaup_Markdown,
  },
})
export default class ContestIntro extends Vue {
  @Prop() contest!: types.ContestAdminDetails;
  @Prop() isLoggedIn!: boolean;
  @Prop() requestsUserInformation!: string;
  @Prop() needsBasicInformation!: boolean;
  @Prop() statement!: types.PrivacyStatement;
  @Prop({ default: false })
  shouldShowModalToLoginWithRegisteredIdentity!: boolean;
  @Prop() userBasicInformation!: types.UserBasicInformation;

  T = T;
  ui = ui;
  omegaup = omegaup;
  penaltyTypes = {
    none: T.contestNewFormNoPenalty,
    problem_open: T.contestNewFormByProblem,
    contest_start: T.contestNewFormByContests,
    runtime: T.contestNewFormByRuntime,
  };
  feedbackTypes = {
    detailed: T.contestNewFormImmediateFeedbackDesc,
    none: '',
    summary: T.contestNewFormImmediateSummaryFeedbackDesc,
  };
  shareUserInformation = null;
  now = Date.now();

  get redirectURL(): string {
    const url = encodeURIComponent(window.location.pathname);
    return `/login/?redirect=${url}`;
  }

  get logoutLink(): string {
    const url = encodeURIComponent(window.location.pathname);
    return `/logout/?redirect=${url}`;
  }

  get differentStartsDescription(): string {
    return ui.formatString(T.contestIntroDifferentStarts, {
      window_length: this.formatTimeInRules(this.contest?.window_length ?? 0),
    });
  }

  get scoreboardDescription(): string {
    const contest = this.contest;
    if (!contest.scoreboard || !contest.finish_time || !contest.start_time) {
      return '';
    }
    if (contest.scoreboard === 100) {
      return T.contestIntroScoreboardTimePercentOneHundred;
    }
    if (contest.scoreboard === 0) {
      return T.contestIntroScoreboardTimePercentZero;
    }
    const minutesPercentage = Math.floor(
      (contest.scoreboard / 100) *
        ((contest.finish_time.getTime() - contest.start_time.getTime()) /
          60000),
    );
    return ui.formatString(T.contestIntroScoreboardTimePercent, {
      window_length: this.formatTimeInRules(minutesPercentage),
    });
  }

  get submissionsGapDescription(): string {
    if (!this.contest.submissions_gap) {
      return '';
    }
    return ui.formatString(T.contestIntroSubmissionsSeparationDesc, {
      window_length: this.formatTimeInRules(this.contest.submissions_gap / 60),
    });
  }

  get penaltyDescription(): string {
    return ui.formatString(T.contestIntroPenaltyDesc, {
      window_length: this.formatTimeInRules(this.contest.penalty),
    });
  }

  get pointsDecayDescription(): string {
    return ui.formatString(T.contestNewFormDecrementFactor, {
      window_length: this.contest.points_decay_factor,
    });
  }

  get isButtonDisabled(): boolean {
    return (
      this.needsBasicInformation ||
      (this.shareUserInformation === null &&
        this.requestsUserInformation !== 'no') ||
      (this.requestsUserInformation === 'required' &&
        !this.shareUserInformation)
    );
  }

  get userInfoStatus() {
    return {
      country: this.userBasicInformation?.country
        ? 'text-success'
        : 'text-danger',
      state: this.userBasicInformation?.state ? 'text-success' : 'text-danger',
      school: this.userBasicInformation?.school
        ? 'text-success'
        : 'text-danger',
    };
  }

  formatTimeInRules(timeInMinutes?: number): string {
    if (!timeInMinutes) {
      return '';
    }
    const hours = Math.floor(timeInMinutes / 60);
    if (hours <= 0) {
      return `${timeInMinutes}m`;
    }
    const minutes = timeInMinutes % 60;
    return `${hours}h${minutes}m`;
  }

  onStartContest(): void {
    const request: types.ConsentStatement = {
      contest_alias: this.contest.alias,
      share_user_information: this.shareUserInformation ?? false,
    };
    if (this.requestsUserInformation !== 'no') {
      request.privacy_git_object_id = this.statement.gitObjectId;
      request.statement_type = this.statement.statementType;
    }

    this.$emit('open-contest', request);
  }
}
